module.exports = __webpack_public_path__ + "media/king.5bd4f636.mp3";